<template>

<PantalladeCarga v-if="$store.state.cargando == true" titulo="Recuperando Presupuesto..."></PantalladeCarga>


<!-- Mensaje No Precio -->
<div class="container content-space-1" v-if="errorCarga == true">

  <div class="row text-center" style="padding:10px;">

      <div class="col shadow pl-5 pr-5 custom-bg-soft rounded text-center" style="padding:25px; text-align: center; border: 1px solid #bdbdbd; padding-top:20px;">
          
          
          <img src="/wp-content/themes/tema-algoritmica/assets/img/blocks/advertencia.png" width="70">

          <p class="text-black" style="font-size:15pt; margin-top:20px;">Upsss!! <br>En estos momentos, no hemos podido recuperar tu presupuesto. <br>Inténtelo de nuevo más tarde. </p>

      </div>
  </div>

</div>



</template>

<script>

import PantalladeCarga from './PantalladeCarga.vue'
import Prices from './MatrixPrices'

export default {
  name: 'LoadPrices',
  components: {
    PantalladeCarga
  },
  props: {

    idPresupuesto: String,
    urlPresupuestos: String,
    conversionValue: Number,
    name: String,
    PeriodoSeleccionado: String,
    PeriodosEscritos: Object
  },
  data: function () {
              return {
                urlPresupuestoWeb: false,
                loaded: false,
                errorCarga: false
              }
  },
  beforeMount: async function(){

    this.CambiarCargando(true);

    //Cargando los Precios de la Base de Datos de Presupuestos
    let datosPresupuesto = await Prices.VerDatosPresupuesto(this.urlPresupuestos, this.idPresupuesto);


    if (datosPresupuesto.status == "OK")
    {
      
      let Precios = datosPresupuesto.data.preciosJSON;
      let Nombre = datosPresupuesto.data.nombreTomador.toUpperCase()
      let Apellidos = datosPresupuesto.data.apellidosTomador.toUpperCase()

      let NombreCompleto = Nombre+" "+Apellidos;


      await this.ActualizarNombreTomador(NombreCompleto);



      let fechaEfecto = datosPresupuesto.data.fechaEfecto;


      let diasHastaEfecto = await Prices.diasHastaEfecto(fechaEfecto);


      if (diasHastaEfecto >= 1)
      {


        let diasPromo = String((diasHastaEfecto+5));

        await this.CambiarPromo(diasPromo);


      }



      if (datosPresupuesto.data.tipoTomador){

        if (datosPresupuesto.data.tipoTomador == "Particular"){

          this.urlPresupuestoWeb = "/presupuesto/familias/"+this.idPresupuesto;
          this.ActualizarTipoTomador("familias");
          this.ActualizarIdPresupuesto(this.idPresupuesto);


        } else {

          this.urlPresupuestoWeb = "/presupuesto/pymes/"+this.idPresupuesto;
          this.ActualizarTipoTomador("pymes");
          this.ActualizarIdPresupuesto(this.idPresupuesto);

        }


      } else {

        this.urlPresupuestoWeb = "/contratacion-online/";

      }

      if (Precios != "")
      {

        let NuevaMatrizPrecios = JSON.parse(Precios);


        await this.ActualizarPrecios(NuevaMatrizPrecios);

      }


      if (this.$store.state.ProductoSeleccionadoEnParrilla)
      {

        if (this.$store.state.ProductoSeleccionadoEnParrilla != "" && this.$store.state.ProductoSeleccionadoEnParrilla != null)
        {

          this.SeleccionarProducto(this.$store.state.ProductoSeleccionadoEnParrilla);


        }

      } else {


        if (datosPresupuesto.data.paqueteSeleccionado.seguroInicial){

          this.SeleccionarProducto(datosPresupuesto.data.paqueteSeleccionado.seguroInicial);
        }

        if (datosPresupuesto.data.paqueteSeleccionado.addons){

          this.AddonsParrilla(datosPresupuesto.data.paqueteSeleccionado.addons);
        }

        if (datosPresupuesto.data.numeroAsegurados){

          this.ActualizarNumeroAsegurados(datosPresupuesto.data.numeroAsegurados);

        }



      }


      if (datosPresupuesto.data.email){


        this.ActualizarEmail(datosPresupuesto.data.email);
        
      }


      if (datosPresupuesto.data.asegurados){


        this.ActualizarAsegurados(datosPresupuesto.data.asegurados);
        
      }

      this.CambiarCargando(false);

    } else {

      console.log("Error, no se ha podido recuperar el presupuesto");
      this.errorCarga = true;
      this.CambiarCargando(false);


    }


  },

  mounted: async function(){

    this.loaded = true;

  },

  methods: {

      ActualizarPrecios : async function(Precios){

        try {

          await this.$store.commit('ActualizarPreciosPresupuesto', Precios);
          let NuevoPricing = await this.CambiarPricingPagina();
          this.$store.commit('ActualizarPricing', NuevoPricing);

          if (this.conversionValue)
          {

            dataLayer.push({'conversionValue': this.conversionValue});

          }

          if (this.name)
          {

            dataLayer.push({'event': this.name+"Conversion"});

          }


          await this.PonerVisible(true);


          
        } catch (error) {


          console.log(error);
          
        }

      },

      PonerVisible : async function(Visible){

        this.$emit('PonerVisible', Visible);

      },

      SeleccionarProducto : function(codigo){

        this.$store.commit('seleccionarProductoParrilla', codigo);    

      },

      AddonsParrilla : function(extensiones){

        this.$store.commit('resetAddonsParrilla', extensiones);

      },


      ActualizarNumeroAsegurados : function(asegurados){

        this.$store.commit('ActualizarNumeroAsegurados', asegurados);

      },

      ActualizarEmail : function(email){

        this.$store.commit('ActualizarEmail', email);

      },


      ActualizarAsegurados : async function(asegurados){

        this.$store.commit('ActualizarAsegurados', asegurados);

      },

      ActualizarTipoTomador : async function(tipo){

        this.$store.commit('ActualizarTipoTomador', tipo);

      },

      ActualizarIdPresupuesto : async function(id){

        this.$store.commit('ActualizarIdPresupuesto', id);

      },


      ActualizarNavbar : async function(navbar){

        this.$store.commit('ActualizarNavbar', navbar);

      },

      CambiarCargando : async function(cargando){

        this.$store.commit('CambiarCargando', cargando);

      },


      CambiarPromo: async function(dias){


        this.$store.commit('CambiarDiasPromoDinamica', dias);
        

      },

      ActualizarNombreTomador: async function(nombre){


        this.$store.commit('ActualizarNombreTomador', nombre);
        

      },

    
      CambiarPricingPagina : async function(){

        try {

          if (this.$store.state.Precios)
          {

            let precios = this.$store.state.Precios[0];

            if (this.$store.state.Pricing.products)
            {

              let productos = this.$store.state.Pricing.products;

              var MatrixProductos = [];

              for (let producto of productos){


                let codigo = producto.cod;


                for (let MPrecio of precios){


                    if (MPrecio.codigo == codigo)
                    {


                      let periodo = this.PeriodoSeleccionado;

                      var precioNuevo = MPrecio.precios[periodo];

                      var precioNuevoAnual = MPrecio.precios.Anual;

                      var CodigoNuevo = MPrecio.codigo;
                      

                      if (precioNuevo > 0)
                      {

                        break;

                      }

                    }


                }

                if (precioNuevo > 0 && codigo == CodigoNuevo || precioNuevoAnual > 0 && codigo == CodigoNuevo)
                {


                  var productoNuevo = producto;

                  if (producto.change == "no")
                  {

                    productoNuevo.note = "Contrata en menos de 2 minutos";

                  } else {


                    productoNuevo.url = "/contratacion-online/";
                    productoNuevo.note = "Contrata en menos de 2 minutos";
                    productoNuevo.button = "<u><b>Contratar Online</b></u><br> <i>en menos de 2 minutos</i>";

                  }

                  productoNuevo.period = this.PeriodosEscritos[this.PeriodoSeleccionado];

                  if (precioNuevo > 0){

                    productoNuevo.price = precioNuevo;
                    productoNuevo.show = true;

                  } else {

                    productoNuevo.price = precioNuevoAnual;
                    productoNuevo.show = false;
                    productoNuevo.period = this.PeriodosEscritos["Anual"];

                  }

                  MatrixProductos.push(productoNuevo);




                } else {
                

                    console.log("Algo no ha funcionado bien");



                }


              }


              if (MatrixProductos.length > 0)
              {


                  return MatrixProductos;

              }


            }

          }

          return this.$store.state.Pricing.products;
          
        } catch (error) {


          return this.$store.state.Pricing.products;
          
        }
      }
    }
  }
</script>
